﻿/* 
Object:         Listbox
Description:    Logic for kendo listboxes
Used in:        Forms or pages with kendo listboxes.
*/

window.listbox = function () {
    
    return {
        /**
         * Move selection from one list to another 
         * @param {any} listFrom
         * @param {any} listTo
         * @param {any} validationField
         * @param {any} validationText
         */
        moveItems: function (listFrom, listTo, validationField, validationText) {
            var somethingChanged = false;

            var listBoxFrom = $("#" + listFrom).data("kendoListBox");
            var listBoxTo = $("#" + listTo).data("kendoListBox");

            var selectedItems = listBoxFrom.select();

            for (var i = 0; i < selectedItems.length; i++) {
                var index = listBoxFrom.items().index(selectedItems[i]);
                var item = listBoxFrom.dataSource.view()[index];

                if (!item.Disabled) {
                    listBoxTo.dataSource.add({
                        Text: item.Text,
                        Value: item.Value,
                        Type: item.Type,
                        UserID: item.UserID,
                        GroupID: item.GroupID,
                        PreComMsgGroupID: item.PreComMsgGroupID,
                        Disabled: item.Disabled
                    });

                    listBoxFrom.remove(selectedItems[i]);

                    somethingChanged = true;
                }
            }

            if (somethingChanged) {
                listBoxFrom.refresh();
                listBoxTo.refresh();

                $(validationField).attr("style", "color:red");
                $(validationField).html(validationText).text();
            }
        }
    }

}();